import React, { useState, useCallback} from 'react';

import cx from 'classnames';

import './PreviewSlideshow.scss';

const useAnimationFrame = (callback) => {
  // Use useRef for mutable variables that we want to persist
  // without triggering a re-render on their change
  const requestRef = React.useRef();
  const previousTimeRef = React.useRef();

  const animate = useCallback((time) => {
    if (previousTimeRef.current !== undefined) {
      const deltaTime = time - previousTimeRef.current; // berechne delta time
      callback(deltaTime);
    }
    previousTimeRef.current = time; // setze alte delta time auf neue deltatime
    requestRef.current = requestAnimationFrame(animate);
  }, [previousTimeRef, callback]);

  React.useLayoutEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [animate]); // Make sure the effect runs only once
};

const Slideshow = ({ slides, delay, duration}) => {
  const [time, setTime] = useState(0.0);

  useAnimationFrame((t) => {
    setTime((time) => time + parseFloat(t));
  });

  const index = Math.floor(time / (delay + duration));
  const from = slides[index % slides.length];

  if (from.type === 0) {
    return <img src={from.url} alt="preview" />;
  } else {
    return <video autoPlay src={from.url} muted />;
  }

};

// first we acceppt elements, later we display streams
const PreviewSlideshow = ({
  elements,
  orientation = 0,
  size = 'normal',
}) => {
  let display_orientation;

  let cl, b;
  switch (size) {
    case 'big': {
      b = "box_big";
      cl = "surface_container_big";
      break;
    }
    case 'small': {
      cl = "surface_container_small";
      b = "box_small";
      break;
    }
    default: // case 'normal'
      b = "box_normal";
      cl = "surface_container_normal";
  }

  /// wenn die ausrichtung Querformat(1) oder Multi(3) ist...
  if (orientation === 1 || orientation === 3) {
    display_orientation = (
      <>
        <div className={cx("box_left", b)}></div>
        <div className={cx("box_right", b)}></div>
      </>
    );
  } else {
    display_orientation = (
      <>
        <div className={cx("box_top", b)}></div>
        <div className={cx("box_bottom", b)}></div>
      </>
    );
  }

  let slides = (elements || []).map((e) => {
    let el = e;
    if (e.element != null) {
      el = e.element;
    }

    return {
      url: el.s3_med_url,
      type: el.type,
      duration: el.duration || 10,
    };
  });

  if ((elements || []).length > 1) {
    return (
      <div className={cx("surface_container", cl)}>
        <Slideshow
          slides={slides}
          delay={2000}
          duration={1500}
          nowebgl
        />
        {display_orientation}
      </div>
    );
  }

  return (
    <div className={cx(cl)}>
      <span>Vorschau</span>
    </div>
  );
};

export { Slideshow };
export default PreviewSlideshow;
